"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarPagination = void 0;
var tailwind_1 = require("../constants/tailwind");
var CLASSES = {
    THIS_MONTH: 'js-this-month',
    NEXT_MONTH: 'js-next-month',
};
/**
 * カレンダーのページ切り替えを管理するクラス
 * 前月と翌月のカレンダーを切り替えるためのクラス
 * グローバルに現在のページを保持し、すべてのカレンダーに反映させる
 */
var CalendarPagination = /** @class */ (function () {
    /**
     * コンストラクタ
     * @param {Element} prevButton
     * @param {Element} nextButton
     * @param {(page: CurrentPage) => void} onPageChange
     */
    function CalendarPagination(prevButton, nextButton, onPageChange) {
        this.onPageChange = onPageChange;
        CalendarPagination.buttonSetList.push({
            prevButton: prevButton,
            nextButton: nextButton,
            onPageChange: onPageChange,
        });
        CalendarPagination.thisMonthElements = document.querySelectorAll(".".concat(CLASSES.THIS_MONTH));
        CalendarPagination.nextMonthElements = document.querySelectorAll(".".concat(CLASSES.NEXT_MONTH));
        this.initEvent();
    }
    /**
     * イベントを初期化
     */
    CalendarPagination.prototype.initEvent = function () {
        var _this = this;
        CalendarPagination.buttonSetList.forEach(function (buttonSet) {
            // 前へボタン
            buttonSet.prevButton.addEventListener('click', function () {
                var _a;
                CalendarPagination.currentPage = 'this';
                CalendarPagination.thisMonthElements.forEach(function (el) {
                    el.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                });
                CalendarPagination.nextMonthElements.forEach(function (el) {
                    el.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                });
                CalendarPagination.buttonSetList.forEach(function (buttonSet) {
                    buttonSet.prevButton.classList.add(tailwind_1.TAILWIND_CLASSES.BUTTON_DISABLED);
                    buttonSet.nextButton.classList.remove(tailwind_1.TAILWIND_CLASSES.BUTTON_DISABLED);
                });
                // コールバック実行
                (_a = _this.onPageChange) === null || _a === void 0 ? void 0 : _a.call(_this, CalendarPagination.currentPage);
            });
            // 次へボタン
            buttonSet.nextButton.addEventListener('click', function () {
                var _a;
                CalendarPagination.currentPage = 'next';
                CalendarPagination.thisMonthElements.forEach(function (el) {
                    el.classList.add(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                });
                CalendarPagination.nextMonthElements.forEach(function (el) {
                    el.classList.remove(tailwind_1.TAILWIND_CLASSES.HIDDEN);
                });
                CalendarPagination.buttonSetList.forEach(function (buttonSet) {
                    buttonSet.prevButton.classList.remove(tailwind_1.TAILWIND_CLASSES.BUTTON_DISABLED);
                    buttonSet.nextButton.classList.add(tailwind_1.TAILWIND_CLASSES.BUTTON_DISABLED);
                });
                // コールバック実行
                (_a = _this.onPageChange) === null || _a === void 0 ? void 0 : _a.call(_this, CalendarPagination.currentPage);
            });
        });
    };
    /**
     * 現在のページ（グローバルステート）
     */
    CalendarPagination.currentPage = 'this';
    /**
     * ボタンと処理をセットで管理するための配列
     */
    CalendarPagination.buttonSetList = [];
    return CalendarPagination;
}());
exports.CalendarPagination = CalendarPagination;
